export default "__VITE_ASSET__CTpbv79c__"